export default __webpack_public_path__ + "media/components/Pages/Index/Images/hss-a05fc40b01d6239edcc81ce9d833ffa9.jpg";